import type { SchoolAssignment, User } from '../types/models'

/**
 * True when the user has an active school assignment for the given school.
 * Used to filter teacher directory results (MAK-236) when the API may still return
 * teachers without an assignment to the scoped school.
 */
export function userHasActiveAssignmentToSchool(user: User, schoolId: string): boolean {
  const assignments = user.school_assignments
  if (!assignments?.length) return false
  return assignments.some(a => a.school_id === schoolId && a.is_active)
}

/**
 * School a scoped user (school admin, teacher) works in by default: their primary
 * assignment, else the first active one. Invited school admins may have no primary.
 */
export function getDefaultSchoolId(
  assignments:
    | ReadonlyArray<Pick<SchoolAssignment, 'school_id' | 'is_primary' | 'is_active'>>
    | null
    | undefined,
): string | null {
  const active = (assignments ?? []).filter(assignment => assignment.is_active !== false)
  return (active.find(a => a.is_primary) ?? active[0])?.school_id ?? null
}
